import React, { Component } from "react";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Button, Col, Form, Modal, Row, Upload } from "antd";
import { UploadInvoiceStates } from "./types/UploadInvoiceTypes";
import { SaveOutlined, InboxOutlined } from "@ant-design/icons";
import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";

export interface UploadInvoiceProps {}

class UploadInvoice extends Component<UploadInvoiceProps & any, UploadInvoiceStates> {
  private readonly initState!: UploadInvoiceStates;
  private token = new Cookies().get("_t");

  constructor(props: (UploadInvoiceProps & any) | any) {
    super(props);

    this.initState = {
      submitting: false,
      showUploadList: false,
      inputImage: [],
      validImage: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  beforeUploadFile = (file: any) => {
    const isPdf = file.type === "application/pdf";
    if (!isPdf) {
      Modal.error({
        title: "Validasi",
        content: "File bukan PDF",
      });

      return false;
    }

    this.setState({
      showUploadList: true,
    });

    this.setState({
      inputImage: file,
      validImage: true,
    });
    return false;
  };

  submitData = async () => {
    this.setState({
      submitting: true,
    });

    const formData = new FormData();
    formData.append("document_file", this.state.inputImage);

    try {
      //   docUploadApiService.setToken(this.token);
      //   await docUploadApiService.uploadTaxInvoice(formData);

      taxOtodisService.setToken(this.token);
      await taxOtodisService.uploadInvoiceTaxOut(formData);

      Modal.success({
        title: "Proses Sukses",
        content: "Berhasil diupload",
      });
      this.setState({
        inputImage: [],
        validImage: false,
        submitting: false,
        showUploadList: false,
      });
    } catch (e: any) {
      this.setState({
        submitting: false,
      });
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Pajak`} breadcrumbMenu={`Upload Faktur`} defaultSelectedKeys={["m-tax-upload-invoice"]} defaultOpenKeys={["sm-tax"]}>
          <Row>
            <Col xl={{ span: 12, push: 6 }} lg={{ span: 12, push: 6 }} md={{ span: 12, push: 4 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form layout="vertical">
                <Upload.Dragger maxCount={1} listType="picture" beforeUpload={this.beforeUploadFile} showUploadList={this.state.showUploadList}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">Hanya boleh mengupload file pdf</p>
                </Upload.Dragger>
                <br />
                <Form.Item>
                  <Button type="primary" loading={this.state.submitting} onClick={(event) => this.submitData()} icon={<SaveOutlined />}>
                    Simpan
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(UploadInvoice), 25);
